import { FieldDef } from '../../lib/boards'
import { Switch } from './ui'

export const inputClass =
  'w-full px-3 py-2 rounded-lg border border-gray-300 dark:border-white/10 bg-white dark:bg-surface-0 text-sm text-gray-900 dark:text-white placeholder:text-gray-400 dark:placeholder:text-gray-500 shadow-sm transition focus:outline-none focus:border-brand-400 focus:ring-2 focus:ring-brand-400/25 disabled:opacity-50'

export const labelClass = 'block text-[13px] font-medium text-gray-700 dark:text-gray-300 mb-1.5'

export type TutorOption = { id: string; name: string }

interface CardFieldInputProps {
  def: FieldDef
  value: any
  onChange: (value: any) => void
  tutors: TutorOption[]
  required?: boolean
  highlight?: boolean
}

export function CardFieldInput({ def, value, onChange, tutors, required, highlight }: CardFieldInputProps) {
  const ring = highlight ? ' border-amber-400 dark:border-amber-500' : ''
  const label = (
    <span>
      {def.label}
      {required && <span className="text-red-500 ml-0.5">*</span>}
    </span>
  )

  if (def.type === 'checkbox') {
    return (
      <div
        className={`flex items-center justify-between gap-3 px-3 py-2.5 rounded-lg border text-sm text-gray-700 dark:text-gray-300 ${
          highlight ? 'border-amber-400 dark:border-amber-500' : 'border-gray-200 dark:border-white/10'
        }`}
      >
        {label}
        <Switch checked={!!value} onChange={onChange} label={def.label} />
      </div>
    )
  }

  return (
    <div>
      <label className={labelClass}>{label}</label>
      {def.type === 'select' ? (
        <select value={value ?? ''} onChange={(e) => onChange(e.target.value)} className={inputClass + ring}>
          <option value="">Select…</option>
          {def.options?.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
        </select>
      ) : def.type === 'tutor' ? (
        <select value={value ?? ''} onChange={(e) => onChange(e.target.value)} className={inputClass + ring}>
          <option value="">Select tutor…</option>
          {tutors.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
        </select>
      ) : def.type === 'textarea' ? (
        <textarea
          rows={3}
          value={value ?? ''}
          onChange={(e) => onChange(e.target.value)}
          placeholder={def.placeholder}
          className={inputClass + ring}
        />
      ) : (
        <input
          type={def.type}
          value={value ?? ''}
          onChange={(e) => onChange(e.target.value)}
          placeholder={def.placeholder}
          className={inputClass + ring}
        />
      )}
    </div>
  )
}
